import script from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"
export * from "./EmptyTable.vue?vue&type=script&setup=true&lang=js"

import "./EmptyTable.vue?vue&type=style&index=0&id=0d6a5d5a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d6a5d5a"]])

export default __exports__